import React from 'react';
import styled from 'styled-components';
import { WorkflowCanvas } from '../components/Workflow/WorkflowCanvas';

const CanvasPage = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  min-height: calc(100dvh - 8rem);
  background: var(--card);
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid var(--line);
  box-shadow: var(--shadow);
  color: var(--ink);

  > * {
    flex: 1;
    min-width: 0;
    min-height: 0;
  }
`;

const CreateWorkflow = () => {
  return (
    <CanvasPage>
      <WorkflowCanvas />
    </CanvasPage>
  );
};

export default CreateWorkflow;
